var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 27",
    width: 22,
    height: 27,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Apple_logo_black-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #000000 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m21.3 9.2c-0.2 0.1-2.9 1.7-2.9 5.1 0 4.1 3.5 5.5 3.6 5.5 0 0.1-0.6 1.9-1.9 3.8-1.1 1.7-2.3 3.4-4.2 3.4-1.8 0-2.3-1.1-4.4-1.1-2.1 0-2.8 1.1-4.5 1.1-1.7 0-2.8-1.5-4.2-3.4-1.5-2.3-2.8-5.7-2.8-9 0-5.2 3.4-8 6.8-8 1.8 0 3.3 1.2 4.4 1.2 1 0 2.7-1.3 4.7-1.3 0.8 0 3.6 0.1 5.4 2.7zm-10-3q-0.2 0-0.4 0c0-0.1 0-0.3 0-0.5 0-1.4 0.7-2.8 1.5-3.7 1-1.1 2.6-1.9 4-2q0 0.2 0 0.5c0 1.4-0.6 2.8-1.4 3.8-0.9 1.1-2.5 1.9-3.7 1.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.d51b57de97f529bf594e07c1f709ee96.svg";
export { ForwardRef as ReactComponent };